export type Template = {
    cId: string;
    templateElement: HTMLTemplateElement;
};

export function getTemplates(element: HTMLElement): Template[] {
    const templatesNodes = element.parentNode?.querySelectorAll<HTMLTemplateElement>('template');
    if (!templatesNodes) {
        return [];
    }

    return Array.from(templatesNodes).map((node) => {
        const id = node.dataset.id;
        if (!id) {
            throw new Error('Template Id is missing');
        }

        return {cId: id, templateElement: node};
    });
}
